import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.15, duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  return (
    <section className="about section-padding" id="about" ref={ref}>
      <div className="section-container">
        <div className="about__grid">
          {/* Images column */}
          <motion.div
            className="about__images"
            custom={0}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={fadeUp}
          >
            <div className="about__img-main">
              <img
                src="https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80"
                alt="Paradise Events wedding setup"
                loading="lazy"
              />
              <div className="about__img-frame" />
            </div>
            <div className="about__img-secondary">
              <img
                src="https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=400&q=80"
                alt="Event decoration"
                loading="lazy"
              />
            </div>
            <div className="about__experience-badge">
              <span className="about__experience-number">8+</span>
              <span className="about__experience-text">Vite<br />Pervoje</span>
            </div>
          </motion.div>

          {/* Content column */}
          <div className="about__content">
            <motion.span
              className="section-label"
              custom={1}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variants={fadeUp}
            >
              Rreth Nesh
            </motion.span>

            <motion.h2
              className="section-title"
              custom={2}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variants={fadeUp}
            >
              Krijojme pervoja qe <em>mbeten pergjithmone</em> ne zemrat tuaja
            </motion.h2>

            <motion.div
              className="gold-line"
              custom={3}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variants={fadeUp}
            />

            <motion.p
              className="about__text"
              custom={3}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variants={fadeUp}
            >
              Paradise Events eshte kompania lidere e planifikimit te eventeve ne Kosove.
              Me mbi 8 vite pervoje dhe 500+ evente te suksesshme, ne transformojme
              cdo moment ne dicka te jashtezakonshme.
            </motion.p>

            <motion.p
              className="about__text"
              custom={4}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variants={fadeUp}
            >
              Nga dasmat me elegante deri te festat me te medhaja, ekipi yne i
              perkushtuar siguron qe cdo detaj te jete perfekte. Ne besojme se cdo
              ngjarie meriton te jete e vecante.
            </motion.p>

            <motion.div
              className="about__features"
              custom={5}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variants={fadeUp}
            >
              {[
                { icon: '01', title: 'Planifikim i Plote', desc: 'Nga koncepti deri ne realizim' },
                { icon: '02', title: 'Dekorim Premium', desc: 'Dizajn unik per cdo event' },
                { icon: '03', title: 'Ekip Profesional', desc: 'Staf me pervoje nderkombetare' },
              ].map((item, i) => (
                <div className="about__feature" key={i}>
                  <span className="about__feature-num">{item.icon}</span>
                  <div>
                    <h4 className="about__feature-title">{item.title}</h4>
                    <p className="about__feature-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
